
import React from 'react';
import { Container, Typography, Button, Box, Grid } from '@mui/material';

const About = () => {
    return (
        <Container>
        <Grid container spacing={2} justifyContent="center" alignItems="center">
                    <Grid item xs={12} sm={6} sx={{ display: 'flex', justifyContent: 'center' }}>
                        {/* <FaFire style={{ fontSize: '5rem' }} /> Homa Icon */}
                    </Grid>
                    <Grid item xs={12} sm={6} sx={{ display: 'flex', justifyContent: 'center' }}>
                        {/* <GiKalash style={{ fontSize: '5rem' }} /> Kalasha Icon */}
                    </Grid>
                </Grid>
                <Typography variant="h3" sx={{ fontWeight: 'bold', fontSize: '3rem', marginTop: '20px' }}>
                    Welcome to Vedamarga
                </Typography>
                <Typography variant="h5" sx={{ marginTop: '10px', fontSize: '1.2rem' }}>
                    Discover the perfect pooja for your needs
                </Typography>
            </Container>
    );
};

export default About;
